import { FilterSelective, Icons } from 'components';
import { IconButton } from '@mui/material';

const status = [
  {
    label: 'همه',
    value: '',
  },
  {
    label: 'فعال',
    value: 'true',
  },
  {
    label: 'غیرفعال',
    value: 'false',
  },
];

const columns = (showAllowedProducts = () => { }, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    filtering: false,
    sorting: false,
  },
  {
    title: 'شناسه کارفرما',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: 'نام کارفرما',
    field: 'name',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: 'وضعیت',
    field: 'enable',
    align: 'center',
    sorting: false,
    filterComponent: (props) => (
      <FilterSelective
        options={status}
        size="small"
        {...props}
        style={{ ...props.style, width: '70%', margin: 'auto' }}
      />
    ),
  },
  {
    title: 'مجوز فروش تمام محصولات',
    field: 'allProductAllow',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) =>
      rd.allProductAllow ? (
        <Icons icon='Accept' color='#8BC34A' size='25' />
      ) : (
        <Icons icon='CloseCircle' color='#F44336' size='25' />
      ),
  },
  ...(actionsList['dealingProdcutList'] ? [{
    title: 'لیست محصولات دارای مجوز',
    field: 'allowedProducts',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => (
      <IconButton onClick={() => showAllowedProducts(rd.id)} size="large">
        <Icons icon='productList' color='#ccc' size='25' />
      </IconButton>
    ),
  }] : []),

];

const colMap = {
  name: 'text',
  id: 'id',
  enable: 'showDisable',
};

export { columns, colMap };
